var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('PosterTextIndex'),_c('PosterTextAdmin'),_c('PosterTextSettings'),_c('PosterTextWooCommerce'),_c('TxProductStats')],1)}
var staticRenderFns = []

export { render, staticRenderFns }